import React from "react";
import CodeBlock from "../Code";
const HealthDescription5 = () => {
  return (
    <>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>건강보험공단 건강검진 내역 조회 API</h3>
          <p>
            정보를 원활히 호출하기 위해서는{" "}
            <span style={{ color: `red` }}>CAPTCHA 인증</span>이 필요합니다.
          </p>
          <h4 className="sub-0">1. 건강검진 내역 조회</h4>
          <p>
            건강보험공단 건강검진 내역 조회 API를 사용하기 위해 먼저 다음 URI를
            POST 방식으로 호출해야 합니다.
          </p>
          <CodeBlock code={`POST /fetch_health_check_up`}></CodeBlock>
          <p>
            건강보험공단 건강검진 내역 조회 시도 요청 본문에 다음과 같은
            파라미터를 작성해야 합니다.
          </p>
          <CodeBlock
            code={`
          [HTTP Request Header]
          {
                          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                          "x-ncp-apigw-api-key": accessKey,
          },`}
          ></CodeBlock>
          <CodeBlock
            code={`
          [HTTP Response Body]
          {
                          "cookie_str": "string"
          }
                `}
          ></CodeBlock>
          <table class="table table-bordered">
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `15%` }}>
                  FILD
                </th>
                <th scope="col" style={{ width: `15%` }}>
                  TYPE
                </th>
                <th scope="col" style={{ width: `55%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>세션 쿠키 문자열</td>
              </tr>
            </tbody>
          </table>
          <h3>Response</h3>
          <p>
            건강검진 내역 조회 API를 호출 하면 아래와 같은 데이터를 보냅니다.
          </p>
          <p>다음은 정상적인 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`
            [HTTP Response Body]
            {
              "cookie_str": "string",
              "code": "string",
              "msg": "string",
              "data": {
                "values": {
                  "0": {
                    "year": "string",
                    "검진일자": "string",
                    "계측검사": {
                      "비만": {
                        "신장": "string",
                        "체중": "string",
                        "허리둘레": "string",
                        "체질량지수": "string"
                      },
                      "시각이상": {
                        "시력(좌/우)": "string"
                      },
                      "청각이상": {
                        "청각(좌/우)": "string"
                      },
                      "고혈압": {
                        "혈압(최고/최저)": "string"
                      }
                    },
                    "요검사": {
                      "신장질환": {
                        "요단백": "string"
                      }
                    },
                    "혈액검사": {
                      "빈혈": {
                        "혈색소": "string"
                      },
                      "당뇨병": {
                        "공복혈당": "string"
                      },
                      "이상지질혈증": {
                        "총콜레스테롤": "",
                        "HDL콜레스테롤": "",
                        "중성지방": "",
                        "LDL콜레스테롤": ""
                      },
                      "만성신장질환": {
                        "혈청크레아티닌": "string",
                        "신사구체여과율(GFR)": "string"
                      },
                      "간장질환": {
                        "AST (SGOT)": "string",
                        "ALT(SGPT)": "string",
                        "감마지티피(y-GTP)": "string"
                      }
                    },
                    "영상검사": {
                      "폐결핵 흉부질환": {
                        "폐결핵 흉부질환": "string"
                      }
                    },
                    "골다공증": {
                      "골다공증": ""
                    }
                  },
                "resulthtml": "<html>...</html>"
            }
                `}
          ></CodeBlock>
          <table class="table table-bordered">
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `10%` }}>
                  FILD
                </th>
                <th scope="col" style={{ width: `10%` }}>
                  TYPE
                </th>
                <th scope="col" style={{ width: `80%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  세션 쿠키 문자열. 세션을 유지하는데 사용되며, 만료시 빈
                  문자열을 반환합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>code</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  요청의 처리 상태를 나타내는 코드. 성공 또는 실패 여부를
                  반환하는 문자열입니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>msg</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>요청 처리에 대한 상세 설명 메시지 입니다.</td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data</td>
                <td style={{ color: `#5DAE46` }}>object</td>
                <td>
                  건강검진 결과 데이터를 포함하는 객체입니다. 각 연도별로 다양한
                  검진 항목의 검사 결과를 포함하며, 검사결과가 없는 항목의 경우
                  공백으로 표시됩니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>resulthtml</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  서버에서 받은 전체 HTML 응답 본문을 그대로 포함하여
                  반환합니다.
                </td>
              </tr>
            </tbody>
          </table>
          <h3>데이터 목록</h3>
          <table class="table table-bordered">
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `33%` }}>
                  DEPTH1
                </th>
                <th scope="col" style={{ width: `33%` }}>
                  DEPTH2
                </th>
                <th scope="col" style={{ width: `33%` }}>
                  DEPTH3
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>계측검사</td>
                <td>비만</td>
                <td>신장</td>
              </tr>
              <tr>
                <td>계측검사</td>
                <td>비만</td>
                <td>체중</td>
              </tr>
              <tr>
                <td>계측검사</td>
                <td>비만</td>
                <td>허리들레</td>
              </tr>
              <tr>
                <td>계측검사</td>
                <td>비만</td>
                <td>체질량지수</td>
              </tr>
              <tr>
                <td>계측검사</td>
                <td>시각이상</td>
                <td>시력(좌/우)</td>
              </tr>
              <tr>
                <td>계측검사</td>
                <td>청각이상</td>
                <td>청각(좌/우)</td>
              </tr>
              <tr>
                <td>계측검사</td>
                <td>고혈압</td>
                <td>혈압(최고/최저)</td>
              </tr>
              <tr>
                <td>요검사</td>
                <td>신장질환</td>
                <td>요단백</td>
              </tr>
              <tr>
                <td>혈액검사</td>
                <td>빈혈</td>
                <td>혈색소</td>
              </tr>
              <tr>
                <td>혈액검사</td>
                <td>당뇨병</td>
                <td>공복혈당</td>
              </tr>
              <tr>
                <td>혈액검사</td>
                <td>이상지혈혈증</td>
                <td>총콜레스테롤</td>
              </tr>
              <tr>
                <td>혈액검사</td>
                <td>이상지혈혈증</td>
                <td>HDL콜레스테롤</td>
              </tr>
              <tr>
                <td>혈액검사</td>
                <td>이상지혈혈증</td>
                <td>중성지방</td>
              </tr>
              <tr>
                <td>혈액검사</td>
                <td>이상지혈혈증</td>
                <td>LDL콜레스테롤</td>
              </tr>
              <tr>
                <td>혈액검사</td>
                <td>만성신장질환</td>
                <td>혈청크레아티닌</td>
              </tr>
              <tr>
                <td>혈액검사</td>
                <td>만성신장질환</td>
                <td>신사구체여과율(GFR)</td>
              </tr>
              <tr>
                <td>혈액검사</td>
                <td>간장질환</td>
                <td>AST (SGOT)</td>
              </tr>
              <tr>
                <td>혈액검사</td>
                <td>간장질환</td>
                <td>ASL (SGPT)</td>
              </tr>
              <tr>
                <td>혈액검사</td>
                <td>간장질환</td>
                <td>감마지피티(Y-GPT)</td>
              </tr>
              <tr>
                <td>영상검사</td>
                <td>폐결행흉부질환</td>
                <td>폐결핵 흉부질환</td>
              </tr>
              <tr>
                <td>골다공증</td>
                <td>골다공증</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <h3 style={{ marginTop: `20px`, marginBottom: `20px` }}>오류코드</h3>
          <p>다음은 오류가 발생한 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`
            {
              "code": "string",
              "msg": "string",
              "data": "string",
              "cookie_str": "string",
              "text": "string"
            }
            `}
          ></CodeBlock>
          <table class="table table-bordered">
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `15%` }}>
                  FILD
                </th>
                <th scope="col" style={{ width: `15%` }}>
                  TYPE
                </th>
                <th scope="col" style={{ width: `55%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  세션 쿠키 문자열. 세션을 유지하는 데 사용되며, 만료시 빈
                  문자열을 반환합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>code</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  요청의 처리 상태를 나타내는 코드. 성공 또는 실패 여부를
                  반환하는 문자열입니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>msg</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  요청 처리에 대한 상세 설명 메시지. 오류 원인 또는 CAPTCHA 인증
                  필요 여부 등을 설명합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>data</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  검진 결과 데이터를 담고 있으며, 실패 시에는 빈 값 {}을
                  반환합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>text</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>서버에서 받은 전체 HTML 응답 본문을 그대로 반환합니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h4 className="sub-1">2. 건강iN 검진현황서비스 사용자 연동</h4>
          <p>
            검진현황 사용자 연동 API를 사용하기 위해 먼저 다음 URI를 POST
            방식으로 호출해야 합니다.
          </p>
          <CodeBlock code={`POST /do_agreement`}></CodeBlock>
          <p>
            검진현황 사용자 연동 API를 사용하기 위해서는 다음과 같은 파라미터를
            작성해야 합니다.
          </p>
          <CodeBlock
            code={`
          [HTTP Request Header]
          {
                          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                          "x-ncp-apigw-api-key": accessKey,
          },`}
          ></CodeBlock>
          <CodeBlock
            code={`
          [HTTP Request Body]
          {
                          "cookie_str ": "string"                
          }
          `}
          ></CodeBlock>
          <table class="table table-bordered">
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `15%` }}>
                  FILD
                </th>
                <th scope="col" style={{ width: `15%` }}>
                  TYPE
                </th>
                <th scope="col" style={{ width: `55%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>세션 쿠키 문자열</td>
              </tr>
            </tbody>
          </table>
          <h3>Response</h3>
          <p>
            검진현황 사용자 연동 API를 호출 하면 아래와 같은 데이터를 보냅니다.
          </p>
          <p>다음은 정상적인 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`
          [HTTP Request Body]
          {
            "cookie_str": "string",
            "code" : "string",
            "msg" : "string",
            "text" : "string"            
          }
          `}
          ></CodeBlock>
          <table class="table table-bordered">
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `15%` }}>
                  FILD
                </th>
                <th scope="col" style={{ width: `15%` }}>
                  TYPE
                </th>
                <th scope="col" style={{ width: `55%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>code</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  오류 또는 성공 여부를 나타내는 코드, 실패 상황에 따라 구체적인
                  코드가 할당됩니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>msg</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  오류 또는 성공에 대한 상세 메시지. 오류가 발생한 이유나 상황에
                  대해 설명합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  성공 오류와 관계없이 반환되는 세션 쿠키 문자열입니다. 오류
                  발생 시에는 빈 문자열을 반환합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>text</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>원본 HTML 텍스트를 반환합니다.</td>
              </tr>
            </tbody>
          </table>
          <h3 style={{ marginTop: `20px`, marginBottom: `20px` }}>오류코드</h3>
          <p>다음은 오류가 발생한 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`
            {
              "code": "ERROR:FAILED_PARSING_COOKIE_STR",
              "msg": "cookie_str 파싱 실패. cookie_str을 확인해주세요.",
              "cookie_str": "",
              "text": ""  
            }
            `}
          ></CodeBlock>
          <CodeBlock
            code={`
            {
              "code": "DO_AGREEMENT:FAILED_ALREADY_AGREED",
              "msg": "이미 연동 동의함",
              "cookie_str": "{}",
              "text": "HTML 원본" 
            }
            `}
          ></CodeBlock>
          <CodeBlock
            code={`
            {
              "code": "DO_AGREEMENT:SUCCESS",
              "msg": "동의 성공",
              "cookie_str": "{}",
              "text": "HTML 원본"
            }
            `}
          ></CodeBlock>
          <CodeBlock
            code={`
            {
              "code": "DO_AGREEMENT:UNKNOWN",
              "msg": "확인 필요",
              "cookie_str": "{}",
              "text": "HTML 원본"
            }
            `}
          ></CodeBlock>
          <table class="table table-bordered">
            <thead>
              <tr class="table-secondary">
                <th scope="col" style={{ width: `15%` }}>
                  FILD
                </th>
                <th scope="col" style={{ width: `15%` }}>
                  TYPE
                </th>
                <th scope="col" style={{ width: `55%` }}>
                  설명
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: `#CE4241` }}>code</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  오류 또는 성공 여부를 나타내는 코드, 실패 상황에 따라 구체적인
                  코드가 할당됩니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>msg</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  오류 또는 성공에 대한 상세 메시지. 오류가 발생한 이유나 상황에
                  대해 설명합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>cookie_str</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>
                  성공 오류와 관계없이 반환되는 세션 쿠키 문자열입니다. 오류
                  발생 시에는 빈 문자열을 반환합니다.
                </td>
              </tr>
              <tr>
                <td style={{ color: `#CE4241` }}>text</td>
                <td style={{ color: `#5DAE46` }}>string</td>
                <td>원본 HTML 텍스트를 반환합니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
export default HealthDescription5;
